import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { TabStates } from 'Shared/TabStates';
import ConversationList from '../ConversationList';

function ConversationsListPage(): React.ReactElement {
    const { t } = useTranslation(['conversationsFeature']);
    const history = useHistory();

    const [showActive, toggleActiveList] = React.useState<boolean>(true);

    const setCurrentConversation = (conversationId: number) => {
        history.push(`/conversations/${conversationId}`);
    };

    const toggleActive = (value: number) => {
        toggleActiveList(value === 0);
    };

    const tabs = [
        { name: t('conversationsFeature:conversationsList.tabs.active'), callBack: toggleActive },
        { name: t('conversationsFeature:conversationsList.tabs.history'), callBack: toggleActive },
    ];

    return (
        <>
            <h1>{t('conversationsFeature:conversationsList.title')}</h1>
            <TabStates tabs={tabs} />
            <ConversationList setCurrentConversation={setCurrentConversation} showActive={showActive} />
        </>
    );
}

export default ConversationsListPage;
